import React from "react";

const IMG = `${import.meta.env.BASE_URL}img/cards`;

/**
 * Reference result body for Andar Bahar (CasinoResult "ab20" branch):
 *   .row.row5.ab20-result > .col-12 (h5.text-center "Andar" + .text-center > .casino-result-cards-item.item × n)
 *     + .col-12.mt-2 (same for "Bahar").
 * Cards alternate starting with Bahar: index even → Bahar, odd → Andar.
 */
export default function Ab20ResultBody({ t1 }) {
  const cards = t1?.card ? String(t1.card).split(",") : [];
  const andar = [];
  const bahar = [];
  cards.forEach((c, i) => (i % 2 === 0 ? bahar : andar).push(c));

  const side = (cls, label, list) => (
    <div className={cls}>
      <h5 className="text-center">{label}</h5>{" "}
      <div className="text-center">
        {list.map((c, i) => (
          <div key={`${i}-${c}`} className="casino-result-cards-item item">
            <img src={`${IMG}/${c}.png`} alt="" />
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="row row5 ab20-result">
      {side("col-12", "Andar", andar)}{" "}
      {side("col-12 mt-2", "Bahar", bahar)}
    </div>
  );
}
